var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.447,
    height: 91.938,
    viewBox: "0 0 85.447 91.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(-2113.93 -2342.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(2113.93 2357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M37.251,6.444H8.6A3.063,3.063,0,0,0,5.737,9.666V64.44H62.983V37.262A7.925,7.925,0,0,0,66.827,38.3a7.818,7.818,0,0,0,1.881-.242v29.6c0,5.339-3.847,9.666-8.587,9.666H8.6C3.859,77.328.012,73,.012,67.662v-58C.012,4.33,3.859,0,8.6,0H35.576Z",
    transform: "translate(-0.012)",
    fill: "#007cab"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2144.069 2341.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(0.061 0.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.669,39.583,41.668,0,55.247,13.357,16.238,52.606,0,55.218Z",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,2.791,2.791,0,14.642,11.851l-2.791,2.791Z",
    transform: "translate(32.617 9.296)",
    fill: "#007cab"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEnabled);
export default __webpack_public_path__ + "static/media/Edit_Enabled.a77fb64587834a95f66e08f94a2bdaaa.svg";
export { ForwardRef as ReactComponent };